<template>
  <modal :open="open" :width="720">
    <template #header>
      <modal-header variant="cross" :saving="loading" @cancel="close()">
        <h1>{{ $t('pages.additionalPayments.createAppPaymentConfirm.title') }}</h1>
      </modal-header>
    </template>

    <div class="mt-6 flex flex-col gap-y-4">
      <!-- Main description -->
      <p class="text-body">
        {{ $t('pages.additionalPayments.createAppPaymentConfirm.description') }}
      </p>

      <!-- Disclaimer in warning box -->
      <div class="bg-yellow-50 border border-yellow-200 rounded-md p-4 text-sm text-yellow-800">
        <div class="flex items-start gap-x-2">
          <svg class="w-5 h-5 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
            <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
          </svg>
          <div>
            <p class="font-medium">{{ $t('pages.additionalPayments.createAppPaymentConfirm.disclaimerTitle') }}</p>
            <p class="mt-1">
              {{ $t('pages.additionalPayments.createAppPaymentConfirm.disclaimer') }}
            </p>
          </div>
        </div>
      </div>

      <!-- Action buttons -->
      <div class="flex justify-end gap-x-3 mt-6">
        <custom-button variant="secondary" :disabled="loading" @click="close()">
          {{ $t('abort') }}
        </custom-button>
        <custom-button variant="primary" :busy="loading" :disabled="loading" @click="confirm()">
          {{ $t('pages.additionalPayments.createAppPaymentConfirm.confirmButton') }}
        </custom-button>
      </div>
    </div>
  </modal>
</template>

<script setup lang="ts">
import Modal from '@utils/Modal/Modal.vue';
import ModalHeader from '@utils/Modal/ModalHeader.vue';
import CustomButton from '@utils/CustomButton.vue';

interface Props {
  open: boolean;
  loading?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits(['update:open', 'confirm']);

const close = () => {
  if (props.loading) return;
  emit('update:open', false);
};

const confirm = () => {
  if (props.loading) return;
  emit('confirm');
};
</script>
